import {PlacementType, SubpageScreenPlacement} from '@amzn/showtime';

import {AESPagesPlacementURI, getUriRegexString} from '../../utils/uriUtils/uriUtils';

const AESSubpagePlacement: SubpageScreenPlacement = {
  id: AESPagesPlacementURI.id,
  uri: getUriRegexString(AESPagesPlacementURI),
  title: 'Application',
  type: PlacementType.SubpageScreen,
};

export default AESSubpagePlacement;
